import { Kinship } from '../Model/Kinship';
import { Third_Kinship } from '../Model/ThirdKinship';
export class KinshipsService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async findOne(thirdId) {
        if (thirdId) {
            const response = await this.apiService.get('thirdKinship/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener el parámetro.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return content.map(response => new Third_Kinship(response).getState());
        }
        else {
            throw new Error(`Error al obtener KinshipId.`);
        }
    }
    async find() {
        const response = await this.apiService.get('params/kinships');
        if (!response.ok) {
            throw new Error(`Error al obtener los Parentescos.`);
        }
        const content = await response.json();
        return content.map(kinship => new Kinship(kinship).getState());
    }
    async saveKinship(kinshipRelation) {
        if (kinshipRelation) {
            const response = await this.apiService.post('thirdKinship/save', kinshipRelation);
            if (!response.ok) {
                throw new Error(`Error al guardar el Parentescos.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener kinship.`);
        }
    }
    async saveKinshipParam(kinship) {
        if (kinship) {
            const response = await this.apiService.post('kinshipParam/save', kinship);
            if (!response.ok) {
                throw new Error(`Error al guardar el Parentescos.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener kinship.`);
        }
    }
    async deleteKinship(kinshipId) {
        if (kinshipId) {
            const response = await this.apiService.get('thirdKinship/delete/' + kinshipId);
            if (!response.ok) {
                throw new Error(`Error al eliminar la relación.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener kinship.`);
        }
    }
}
